import { render, staticRenderFns } from "./ImoFalForm1MenuGrid.vue?vue&type=template&id=845c5310"
import script from "./ImoFalForm1MenuGrid.vue?vue&type=script&lang=js"
export * from "./ImoFalForm1MenuGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports